import { StyleSheet } from 'react-native';
import { brand, progressColor } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderRadius: 30,
    alignItems: 'center',
    height: 48,
  },
  containerMobile: {
    backgroundColor: progressColor.background,
    paddingVertical: 8,
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    alignItems: 'center',
    minHeight: 106,
  },
  left: {
    flexGrow: 1,
    minWidth: 285,
    gap: 8,
    flexDirection: 'row',
    paddingRight: 24,
  },
  leftInner: {
    flexGrow: 1,
    justifyContent: 'flex-start',
  },
  right: {
    flexGrow: 1.5,
    position: 'relative',
    paddingRight: 24,
  },
  rightV3: {
    flexGrow: 3,
    position: 'relative',
    paddingRight: 24,
  },
  iconPromo: {
    width: 32,
    height: 32,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 17,
    color: brand.main.orange,
  },
  subtitle: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 13,
    color: brand.main.orange,
  },
  progressWrapper: {
    width: '100%',
    position: 'relative',
    height: 20,
    justifyContent: 'center',
  },
  progressWrapperMobile: {
    width: '100%',
    position: 'relative',
    height: 32,
    justifyContent: 'flex-start',
    paddingVertical: 24,
    paddingLeft: 16,
    paddingRight: 24,
  },

  textWrapper: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
  },
  textWrapperMobile: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
